import {
  CalendarOutlined,
  CloseOutlined,
  LeftOutlined,
  UserDeleteOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import "./BookingChange.scss";
import { Button, Input, message, Row } from "antd";
import { useState } from "react";
import { cancelBooking } from "services/SauceService";
import { Booking } from "interfaces/booking";

interface Props {
  changeType?: "reschedule" | "cancel";
}

const BookingChange: React.FC<Props> = (props) => {
  const { changeType: changeTypeProp } = props;
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [reason, setReason] = useState<string>("");
  const [changeType, setChangeType] =
    useState<Props["changeType"]>(changeTypeProp);
  const location = useLocation();
  const { state } = location;
  const { booking } = state as { booking: Booking };

  const onClickCancel = async () => {
    setLoading(true);
    const params = {
      bookingId: booking.bookingId,
      collabId: booking.collabId,
      reason,
    };
    try {
      await cancelBooking(params);
      navigate("/book/cancelled");
    } catch (error) {
      message.error("Failed to cancel collab");
    }
    setLoading(false);
  };

  const onClickReschedule = async () => {
    navigate(`/collab/book/${booking.collabId}`, {
      state: { previousBooking: booking },
    });
  };

  return (
    <div className="booking-change">
      <Row
        justify="space-between"
        style={{ alignItems: "center", marginTop: 6 }}
      >
        <LeftOutlined
          style={{ cursor: "pointer" }}
          onClick={() => navigate(-1)}
        />
      </Row>
      <div className="warning-card" style={{ marginTop: 20, flex: 1 }}>
        <div className="warning-title">
          Before you make
          <br />
          changes
        </div>
        <div className="warning-desc">
          Changes and NO SHOWS to a booked collaboration will impact your
          ranking.
        </div>
        <div className="warning-alert">
          All actions below negatively affect
          <br />
          your ranking. Read carefully!
        </div>

        <div
          className={`warning-box reschedule ${
            changeType === "reschedule" ? "selected" : ""
          }`}
          onClick={() => setChangeType("reschedule")}
        >
          <CalendarOutlined className="warning-icon reschedule" />
          <div>
            <span className="warning-label">Reschedule</span>
            <div className="warning-text">
              Sometimes things come up, but rescheduling still lowers your
              ranking.
            </div>
          </div>
        </div>

        <div
          className={`warning-box cancel ${
            changeType === "cancel" ? "selected" : ""
          }`}
          onClick={() => setChangeType("cancel")}
        >
          <CloseOutlined className="warning-icon cancel" />
          <div>
            <span className="warning-label">Cancel</span>
            <div className="warning-text">
              Canceling a collab is more serious and significantly lowers your
              ranking. Brands may be less likely to invite you in the future.
            </div>
          </div>
        </div>
        {changeType === "cancel" && (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ width: "100%", margin: "12px 0 20px 0" }}>
              <span
                style={{ width: "100%", marginTop: 20 }}
                className="body-16-regular-poppins"
              >
                Please provide a reason for canceling:
              </span>
              <Input.TextArea
                rows={2}
                value={reason}
                onChange={(evt) => setReason(evt.target.value)}
              />
            </div>
          </div>
        )}
        <div
          className={`card-yellow`}
          style={{ alignItems: "flex-start", border: "none" }}
        >
          <UserDeleteOutlined className="warning-icon no-show" />
          <div>
            <span className="warning-label">No-Show</span>
            <div className="warning-text">
              Not showing up will lead to{" "}
              <span className="strong alert">significant ranking drop</span>,
              and may result in being <span className="strong">banned</span>{" "}
              from the network.
            </div>
          </div>
        </div>
      </div>
      <div>
        {changeType === "cancel" && (
          <Button
            className="warning-btn-cancel"
            onClick={onClickCancel}
            loading={loading}
            disabled={!reason}
          >
            Cancel anyway
          </Button>
        )}

        {changeType === "reschedule" && (
          <Button className="warning-btn-cancel" onClick={onClickReschedule}>
            Reschedule
          </Button>
        )}
        <Button
          type="text"
          onClick={() => navigate(-1)}
          style={{ width: "100%" }}
        >
          Go back
        </Button>
      </div>
    </div>
  );
};

export default BookingChange;
